import { render, staticRenderFns } from "./TransferHistoryDetails.vue?vue&type=template&id=29c3bf15"
import script from "./TransferHistoryDetails.vue?vue&type=script&lang=ts"
export * from "./TransferHistoryDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports